"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Modal_1 = __importDefault(require("@web/common/Modal"));
(() => {
    const recommendationModal = document.getElementById('dashboard-recommendation-modal-open');
    if (recommendationModal) {
        (() => new Modal_1.default(recommendationModal))();
    }
})();
